import { memo } from "react"
import { Link } from "react-router-dom"
import { DisplayFromBellow, StaggeringTextAnimation } from "../parallax"

export const Footer = memo(() => {
  return (
    <footer className="border-t border-gray-200 dark:border-white/10 bg-white dark:bg-neutral-950 text-gray-700 dark:text-gray-300">
      <div className="mx-auto max-w-7xl px-6 lg:px-12 py-10">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div className="max-w-md space-y-3">
            <h2 className="text-2xl font-black text-black dark:text-white">Ahmad</h2>
            <p className="text-sm leading-6 text-gray-600 dark:text-gray-400">
              Fullstack & mobile developer building high-quality web and native experiences — from React to Futter.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            <div className="space-y-3">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-black dark:text-white">Quick Links</p>
              <div className="space-y-2 text-s m">
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <Link to="/">Home</Link>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <Link to="/#about">About</Link>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <Link to="/notes">Notes</Link>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <Link to="/#contact">Contact</Link>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
              </div>
            </div>
            <div className="space-y-3">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-black dark:text-white">Get in touch</p>
              <p className="text-sm text-gray-600 dark:text-gray-300">kassimahmad023@gmail.com</p>
            </div>
            <div className="space-y-3">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-black dark:text-white">Socials</p>
              <div className="space-y-2 text-sm">
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <a href="https://github.com/ahmadOlawale008" target="_blank" rel="noreferrer">GitHub</a>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <a href="https://www.linkedin.com/in/kassim-olawale-770b06239/" target="_blank" rel="noreferrer">LinkedIn</a>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <a href="https://twitter.com/olawalekassim1/" target="_blank" rel="noreferrer">Twitter</a>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
                <DisplayFromBellow>
                  <StaggeringTextAnimation asChild className="block text-gray-600 dark:text-gray-300 hover:text-black dark:hover:text-white">
                    <a href="https://www.instagram.com/olawale_0009/" target="_blank" rel="noreferrer">Instagram</a>
                  </StaggeringTextAnimation>
                </DisplayFromBellow>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-10 border-t border-gray-200 dark:border-white/10 pt-6 text-sm text-gray-500 dark:text-gray-400 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p>© Kassim Olawale 2026. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-3 text-gray-600 dark:text-gray-300">
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <Link to="/">Home</Link>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <Link to="/#about">About</Link>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <Link to="/notes">Notes</Link>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <a href="https://github.com/ahmadOlawale008" target="_blank" rel="noreferrer">GitHub</a>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <a href="https://www.linkedin.com/in/kassim-olawale-770b06239/" target="_blank" rel="noreferrer">LinkedIn</a>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <a href="https://twitter.com/olawalekassim1/" target="_blank" rel="noreferrer">Twitter</a>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <a href="https://www.instagram.com/olawale_0009/" target="_blank" rel="noreferrer">Instagram</a>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
            <DisplayFromBellow>
              <StaggeringTextAnimation asChild className="hover:text-black dark:hover:text-white">
                <Link to="/#contact">Contact</Link>
              </StaggeringTextAnimation>
            </DisplayFromBellow>
          </div>
        </div>
      </div>
    </footer>
  )
})
